//====================================================
//  Function: FAQ Create
//====================================================
var counterFaq = 1
var faqResultVisual = $('.js-faq-info-result')
var faqGroup = $('.js-faq-group')

function componentFAQCreate() {
  if ($('.js-faq-group').length) {
    faqGroup = $('.js-faq-group')

    $(document).on('click', '.js-faq-add', function () {
      console.log('Klik')
      var parent = $(this).closest('.js-label-subgroup')
      addNewFaq(parent)
      addToFaqResultCode()
    })

    $(document).on('click', '.js-faq-remove', function () {
      var parent = $(this).closest('.js-label-subgroup')
      if (parent.find('.js-faq-item').length > 1) {
        $(this).closest('.js-faq-item').remove()
        addToFaqResultCode()
      }
    })

    $(document).on('click', '.js-faq-add-category', function () {
      var parent = $(this).closest('.js-labels-group')
      addNewFaqCategory(parent)
      addToFaqResultCode()
    })

    $(document).on('click', '.js-faq-remove-category', function () {
      if ($('.js-faq-item-main').length > 1) {
        $(this).closest('.js-faq-item-main').remove()
        addToFaqResultCode()
      }
    })

    $('.js-faq-input-title').keyup(function () {
      addToFaqResultCode()
    })

    $(document).on(
      'keyup',
      '.js-faq-input-title, .js-faq-input-perex, .js-faq-input-category',
      function () {
        addToFaqResultCode()
      },
    )
  }
}

function addToFaqResultCode() {
  var arrayResultFaq = []
  var arrayResultFaqString = ''

  var templateBoxHeader = `
    <div class="content-wrapper faq-block js-faq-block">
  `
  arrayResultFaq.push(templateBoxHeader)

  var inputTitle = $('.js-faq-input-title')
  var inputTitleValue = inputTitle.val()
  var templateBoxtitle = `
		<div class="h4 homepage-group-title">${inputTitleValue}</div>
		<div class="container tabs-group js-tabs-group">
			<div class="faq-group">
  `

  arrayResultFaq.push(templateBoxtitle)

  var templateBoxtitleAside = `
		<aside class="faq-side">
			<ul class="faq-side-list">
  `
  arrayResultFaq.push(templateBoxtitleAside)

  $('.js-faq-item-main').each(function (index) {
    var faqSideItemValue = $(this).find('.js-faq-input-category').val()
    if (index === 0) {
      var templateBoxItemFaq = `
					<li class="faq-side-list__item js-tab-list-item is-active" data-id="faq-tab-${index}">${faqSideItemValue}</li>
				`
    } else {
      var templateBoxItemFaq = `
					<li class="faq-side-list__item js-tab-list-item" data-id="faq-tab-${index}">${faqSideItemValue}</li>
				`
    }
    arrayResultFaq.push(templateBoxItemFaq)
  })

  var templateBoxtitleAsideBottom = `

			</ul>
		</aside>
	`
  arrayResultFaq.push(templateBoxtitleAsideBottom)

  var templateBoxtitleContentTop = `
		<div class="faq-content">
			<div class="tabs-content js-tabs-content">

	`
  arrayResultFaq.push(templateBoxtitleContentTop)

  $('.js-faq-item-main').each(function (index) {
    var faqSideItemValue = $(this).find('.js-faq-input-category').val()
    var mainItemFaq = $(this)
    if (index === 0) {
      var templateBoxtitleContentTopInner = `
				<div class="tab-content__item js-tab-content-item is-active" data-id="faq-tab-${index}">
					<div class="faq-content-title">${faqSideItemValue}</div>
					<div class="accordion accordion--classic js-accordion-group">
			`
    } else {
      var templateBoxtitleContentTopInner = `
				<div class="tab-content__item js-tab-content-item" data-id="faq-tab-${index}">
					<div class="faq-content-title">${faqSideItemValue}</div>
					<div class="accordion accordion--classic js-accordion-group">
			`
    }

    arrayResultFaq.push(templateBoxtitleContentTopInner)

    mainItemFaq.find('.js-faq-item').each(function () {
      var element = $(this)
      var faqTitle = element.find('.js-faq-input-title').val()
      var faqPerex = element.find('.js-faq-input-perex').val()
      var templateBoxItemFaq = `
        <div class="accordion__item js-accordion-item">
					<div class="accordion__trigger js-accordion-trigger">${faqTitle}</div>
					<div class="accordion__content js-accordion-content"><p>${faqPerex}</p></div>
				</div>
      `

      arrayResultFaq.push(templateBoxItemFaq)
    })

    var templateBoxtitleContentBottomInner = `
				</div>
			</div>
		`

    arrayResultFaq.push(templateBoxtitleContentBottomInner)
  })

  var templateBoxFooterFaq = `
					</div>
				</div>
			</div>
		</div>
	</div>
  `

  //  $('.js-faq-info-result')[0].outerHTML.replace(/(\r\n|\n|\r)/gm, "");

  arrayResultFaq.push(templateBoxFooterFaq)
  arrayResultFaq = arrayResultFaq.join(' ')

  faqResultVisual.empty()
  faqResultVisual.append(arrayResultFaq)

  arrayResultFaqString = $(
    '.js-faq-info-result .js-faq-block',
  )[0].outerHTML.replace(/(\r\n|\n|\r)/gm, '')

  $('.js-code-result').empty()
  $('.js-code-result').text(arrayResultFaqString)
}

function addNewFaq(element) {
  counterFaq++
  if ($('html.is-sk').length) {
    var newFaqTemplate = `
				<div class="labels-group__item js-faq-item" data-id="${counterFaq}">
					<div class="labels-group__content">
							<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
									<h2 class="delta">Otázka</h2>
							</div>
							<div class="js-append">
								<div class="row gutter-10 margin-bottom-1-2 align-items-center">
										<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
												<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Titulok</label>
										</div>
										<div class="col-12 col-sm-7 col-xl-8">
												<div class="label__input">
														<input class="form__input form__input--small form__input--outline js-faq-input-title" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor">
												</div>
										</div>
								</div>
								<div class="row gutter-10 margin-bottom-1-2 align-items-center">
										<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
												<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Obsah</label>
										</div>
										<div class="col-12 col-sm-7 col-xl-8">
												<div class="label__input">
														<input class="form__input form__input--small form__input--outline js-faq-input-perex" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor">
												</div>
										</div>
								</div>
							</div>
							<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
									<div class="col-12 txt-r">
											<div class="label__action justify-content-end">
													<div class="label__add js-faq-add">
															<svg class="icon-svg icon-plus">
																	<use xlink:href="images/sprites.svg#icon-plus"></use>
															</svg>
															<span>Pridať otázku</span>
													</div>
													<div class="label__remove js-faq-remove">
															<svg class="icon-svg icon-close">
																	<use xlink:href="images/sprites.svg#icon-close"></use>
															</svg>
															<span>Odobrať otázku</span>
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
			`
  }
  if ($('html.is-hu').length) {
    var newFaqTemplate = `
				<div class="labels-group__item js-faq-item" data-id="${counterFaq}">
					<div class="labels-group__content">
							<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
									<h2 class="delta">Kérdés</h2>
							</div>
							<div class="js-append">
								<div class="row gutter-10 margin-bottom-1-2 align-items-center">
										<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
												<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Címlapon</label>
										</div>
										<div class="col-12 col-sm-7 col-xl-8">
												<div class="label__input">
														<input class="form__input form__input--small form__input--outline js-faq-input-title" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor">
												</div>
										</div>
								</div>
								<div class="row gutter-10 margin-bottom-1-2 align-items-center">
										<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
												<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Tartalomjegyzék</label>
										</div>
										<div class="col-12 col-sm-7 col-xl-8">
												<div class="label__input">
														<input class="form__input form__input--small form__input--outline js-faq-input-perex" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor">
												</div>
										</div>
								</div>
							</div>
							<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
									<div class="col-12 txt-r">
											<div class="label__action justify-content-end">
													<div class="label__add js-faq-add">
															<svg class="icon-svg icon-plus">
																	<use xlink:href="images/sprites.svg#icon-plus"></use>
															</svg>
															<span>Kérdés hozzáadása</span>
													</div>
													<div class="label__remove js-faq-remove">
															<svg class="icon-svg icon-close">
																	<use xlink:href="images/sprites.svg#icon-close"></use>
															</svg>
															<span>távolítsa el a kérdést</span>
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
			`
  }
  element.find('> .js-append').append(newFaqTemplate)
}

function addNewFaqCategory(element) {
  counterFaq++
  if ($('html.is-sk').length) {
    var newFaqCategoryTemplate = `
				<div class="labels-group__content--top js-label-subgroup js-faq-item-main" data-id="${counterFaq}">
					<div class="label-group__category">
						<div class="row gutter-10 margin-bottom-1-2 align-items-center">
							<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
								<label class="form__label form__label--classic" for="${counterFaq}_category">Názov kategorie</label>
							</div>
							<div class="col-12 col-sm-7 col-xl-8">
								<div class="label__input">
									<input class="form__input form__input--small form__input--outline js-faq-input-category" type="text" id="${counterFaq}_category" name="${counterFaq}_category" value="Názov kategorie">
								</div>
							</div>
						</div>
					</div>
					<div class="js-append">
						<div class="labels-group__item js-faq-item" data-id="${counterFaq}">
							<div class="labels-group__content">
									<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
											<h2 class="delta">Otázka</h2>
									</div>
									<div class="row gutter-10 margin-bottom-1-2 align-items-center">
											<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
													<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Titulok</label>
											</div>
											<div class="col-12 col-sm-7 col-xl-8">
													<div class="label__input">
															<input class="form__input form__input--small form__input--outline js-faq-input-title" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor">
													</div>
											</div>
									</div>
									<div class="row gutter-10 margin-bottom-1-2 align-items-center">
											<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
													<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Obsah</label>
											</div>
											<div class="col-12 col-sm-7 col-xl-8">
													<div class="label__input">
															<input class="form__input form__input--small form__input--outline js-faq-input-perex" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor">
													</div>
											</div>
									</div>
									<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
											<div class="col-12 txt-r">
													<div class="label__action justify-content-end">
															<div class="label__add js-faq-add">
																	<svg class="icon-svg icon-plus">
																			<use xlink:href="images/sprites.svg#icon-plus"></use>
																	</svg>
																	<span>Pridať otázku</span>
															</div>
															<div class="label__remove js-faq-remove">
																	<svg class="icon-svg icon-close">
																			<use xlink:href="images/sprites.svg#icon-close"></use>
																	</svg>
																	<span>Odobrať otázku</span>
															</div>
													</div>
											</div>
									</div>
							</div>
						</div>
					</div>
					<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
						<div class="col-12 txt-r">
							<div class="label__action justify-content-end">
								<div class="label__add js-faq-add-category">
											<svg class="icon-svg icon-plus">
												<use xlink:href="images/sprites.svg#icon-plus"></use>
											</svg><span>Pridať kategóriu</span>
								</div>
								<div class="label__remove js-faq-remove-category">
											<svg class="icon-svg icon-close">
												<use xlink:href="images/sprites.svg#icon-close"></use>
											</svg><span>Odobrať kategóriu</span>
								</div>
							</div>
						</div>
					</div>
			</div>
			`
  }
  if ($('html.is-hu').length) {
    var newFaqCategoryTemplate = `
				<div class="labels-group__content--top js-label-subgroup js-faq-item-main" data-id="${counterFaq}">
					<div class="label-group__category">
						<div class="row gutter-10 margin-bottom-1-2 align-items-center">
							<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
								<label class="form__label form__label--classic" for="${counterFaq}_category">A kategória neve</label>
							</div>
							<div class="col-12 col-sm-7 col-xl-8">
								<div class="label__input">
									<input class="form__input form__input--small form__input--outline js-faq-input-category" type="text" id="${counterFaq}_category" name="${counterFaq}_category" value="A kategória neve">
								</div>
							</div>
						</div>
					</div>
					<div class="js-append">
						<div class="labels-group__item js-faq-item" data-id="${counterFaq}">
							<div class="labels-group__content">
									<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
											<h2 class="delta">Kérdés</h2>
									</div>
									<div class="row gutter-10 margin-bottom-1-2 align-items-center">
											<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
													<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Címlapon</label>
											</div>
											<div class="col-12 col-sm-7 col-xl-8">
													<div class="label__input">
															<input class="form__input form__input--small form__input--outline js-faq-input-title" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor">
													</div>
											</div>
									</div>
									<div class="row gutter-10 margin-bottom-1-2 align-items-center">
											<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
													<label class="form__label form__label--classic" for="faq_${counterFaq}_title">Tartalomjegyzék</label>
											</div>
											<div class="col-12 col-sm-7 col-xl-8">
													<div class="label__input">
															<input class="form__input form__input--small form__input--outline js-faq-input-perex" type="text" id="faq_${counterFaq}_title" name="faq_${counterFaq}_title" value="Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor">
													</div>
											</div>
									</div>
									<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
											<div class="col-12 txt-r">
													<div class="label__action justify-content-end">
															<div class="label__add js-faq-add">
																	<svg class="icon-svg icon-plus">
																			<use xlink:href="images/sprites.svg#icon-plus"></use>
																	</svg>
																	<span>Kérdés hozzáadása</span>
															</div>
															<div class="label__remove js-faq-remove">
																	<svg class="icon-svg icon-close">
																			<use xlink:href="images/sprites.svg#icon-close"></use>
																	</svg>
																	<span>Kérdés eltávolítása</span>
															</div>
													</div>
											</div>
									</div>
							</div>
						</div>
					</div>
					<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
						<div class="col-12 txt-r">
							<div class="label__action justify-content-end">
								<div class="label__add js-faq-add-category">
											<svg class="icon-svg icon-plus">
												<use xlink:href="images/sprites.svg#icon-plus"></use>
											</svg><span>Kategória hozzáadása</span>
								</div>
								<div class="label__remove js-faq-remove-category">
											<svg class="icon-svg icon-close">
												<use xlink:href="images/sprites.svg#icon-close"></use>
											</svg><span>Kategória eltávolítása</span>
								</div>
							</div>
						</div>
					</div>
			</div>
			`
  }
  element.append(newFaqCategoryTemplate)
}
